import type { PublishingRuleViolationsView } from "@slfinrtl/ui-bff-routes"
import { getPublishingRuleViolationsViewRoute, PublishingRuleViolationVisibility } from "@slfinrtl/ui-bff-routes"
import { useCallback, useEffect, useState } from "react"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { useBff } from "src/hooks"
import { useVehicleDetailsContext } from "../context/VehicleDetailsContext"
import { PublishingRuleViolations } from "./components/PublishingRuleViolations"

export const PublishingRuleViolationsContainer = withErrorHandler(() => {
	const [view, setView] = useState<PublishingRuleViolationsView>()
	const { inventoryId, notify, subscribe } = useVehicleDetailsContext()

	const fetchView = useBff(
		getPublishingRuleViolationsViewRoute,
		{
			body: undefined,
			pathParams: { inventoryId },
			queryParams: {},
		},
		"inline",
	)

	const updateView = useCallback(() => {
		fetchView().then(setView)
	}, [fetchView])

	useEffect(() => {
		if (view) {
			notify({ event: "publishingRuleViolationsChanged", payload: view })
		}
	}, [notify, view])

	useEffect(updateView, [updateView])

	useEffect(() => {
		subscribe("inventoryInformationUpdated", updateView)
		subscribe("visibilityUpdated", updateView)
	}, [subscribe, updateView])

	if (!view || view.visibility === PublishingRuleViolationVisibility.VISIBLE_IN_SEARCH) {
		return null
	}

	return (
		<>
			<PublishingRuleViolations inventoryId={inventoryId} view={view} />
			<ErrorNotificationInline />
		</>
	)
})
